import { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';

// Portes, IVA e limiar de envio grátis, tal como a API os define.
// Sem regras não mostramos valores — nunca valores errados.
const usePricingRules = () => {
  const [pricingRules, setPricingRules] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchPricingRules = async () => {
      try {
        const response = await axiosInstance.get('/order/pricing-rules');
        if (!cancelled) setPricingRules(response);
      } catch (err) {
        if (!cancelled) setPricingRules(null);
      }
    };

    fetchPricingRules();
    return () => {
      cancelled = true;
    };
  }, []);

  return pricingRules;
};

export default usePricingRules;
